import { CloneTableToolbar } from '@/features/shared/components/cloneTable/CloneTableToolbar';
import {
  cloneExecutionColumnOptions,
  cloneExecutionDefaultColumnVisibilityModel,
  cloneExecutionDefaultSortDirection,
  cloneExecutionDefaultSortKey,
  cloneExecutionSortOptions,
  type CloneExecutionSortDirection,
  type CloneExecutionSortKey,
  cloneExecutionStatusOptions,
} from '@/features/suites/pages/suiteExecutionsPageCloneConfig';
import type { CloneDateQuickFilter } from '@/features/shared/hooks/useCloneDateWindow';
import type { GridColumnVisibilityModel } from '@/ui/primitives';
import type { SuiteExecutionStatus } from '@flowqa/shared';
import type { Dayjs } from 'dayjs';
import type { ReactElement } from 'react';

type SuiteExecutionsCloneToolbarProps = {
  title?: string;
  onDebouncedCloneSearchChange: (value: string) => void;
  columnVisibilityModel: GridColumnVisibilityModel;
  onColumnVisibilityModelChange: (nextModel: GridColumnVisibilityModel) => void;
  sortKey: CloneExecutionSortKey;
  sortDirection: CloneExecutionSortDirection;
  onSortChange: (
    sortKey: CloneExecutionSortKey,
    sortDirection: CloneExecutionSortDirection,
  ) => void;
  filterStatuses: SuiteExecutionStatus[];
  onFilterStatusesChange: (next: SuiteExecutionStatus[]) => void;
  filterTags: string[];
  onFilterTagsChange: (next: string[]) => void;
  dateQuickFilter: CloneDateQuickFilter;
  onDateQuickFilterChange: (next: CloneDateQuickFilter) => void;
  fromDate: Dayjs | null;
  toDate: Dayjs | null;
  onFromDateChange: (next: Dayjs | null) => void;
  onToDateChange: (next: Dayjs | null) => void;
  availableTags: string[];
};

export const SuiteExecutionsCloneToolbar = (
  props: SuiteExecutionsCloneToolbarProps,
): ReactElement => (
  <CloneTableToolbar<CloneExecutionSortKey, SuiteExecutionStatus>
    title="Executions"
    searchAriaLabel="Search suite executions"
    defaultColumnVisibilityModel={cloneExecutionDefaultColumnVisibilityModel}
    columnOptions={cloneExecutionColumnOptions}
    defaultSortKey={cloneExecutionDefaultSortKey}
    defaultSortDirection={cloneExecutionDefaultSortDirection}
    sortOptions={cloneExecutionSortOptions}
    statusOptions={cloneExecutionStatusOptions}
    includeLatestQuickFilter
    statusFilterLabel="Status"
    {...props}
  />
);
